var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fm-modal"}},[_c('div',{ref:"fmModal",staticClass:"fm-modal",on:{"click":_vm.hideModal}},[_c('div',{staticClass:"modal-dialog",class:_vm.modalSize,attrs:{"role":"document"},on:{"click":function($event){$event.stopPropagation();}}},[_c(_vm.modalName,{tag:"component"})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }